/**
 * 主题管理: 深浅色两态 + 应用与持久化.
 *
 * 主题定义在 design/theme.css (daisyUI 的 theme plugin), 这里只负责选择与落地:
 * - light 采用 Claude 设计 token, dark 是 light 语义的暗色重映射;
 * - 首屏由 index.html 的内联脚本提前写入 data-theme, 避免主题闪烁(FOUC);
 * - `data-theme` 同时驱动 daisyUI 的 theme-controller 与全局语义 token.
 */

export type ThemeName = 'light' | 'dark'

export const DEFAULT_THEME: ThemeName = 'light'

const STORAGE_KEY = 'oma-gendu:theme'

export function isThemeName(value: string | null | undefined): value is ThemeName {
  return value === 'light' || value === 'dark'
}

export function resolveInitialTheme(): ThemeName {
  const stored = localStorage.getItem(STORAGE_KEY)
  if (isThemeName(stored)) return stored
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : DEFAULT_THEME
}

export function applyTheme(theme: ThemeName): void {
  const root = document.documentElement
  root.dataset.theme = theme
  root.style.colorScheme = theme === 'dark' ? 'dark' : 'light'
  localStorage.setItem(STORAGE_KEY, theme)
}
